export const ROOMS_BOOKING_URL = "https://www.scidoo.com/preventivov2/?cod=1649&IDsettore_specifico=574&settore=1&settore_unico=1";
export const WHATSAPP_NUMBER = "393500241768";
export const SHOP_PHONE = "+393500241768";

export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
